import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Field } from "@hulahoop/ui";
import { OptionSelect } from "@/components/shared/forms/OptionSelect";
import type { Language } from "@/domain/common";
import type { InvestorWizardFormData } from "@/domain/validation/investorSchemas";
import { getCountryOptions, SUPPORTED_COUNTRY_CODES } from "@/utils/countries";
import { LANGUAGES } from "../config/investorDisplay";
import { useInvestorLabels } from "../hooks/useInvestorLabels";
import { WizardTextField } from "./WizardTextField";

export function CreateInvestorContactStep() {
  const { t, i18n } = useTranslation();
  const form = useFormContext<InvestorWizardFormData>();
  const { languageLabels } = useInvestorLabels();
  return (
    <>
      <div className="grid gap-(--card-gap) sm:grid-cols-2">
        <WizardTextField
          name="email"
          label="investors.attributes.email"
          placeholder="investors.wizard.placeholders.email"
          required
        />
        <WizardTextField
          name="phone"
          label="investors.attributes.phone"
          placeholder="investors.wizard.placeholders.phone"
        />
      </div>
      <WizardTextField
        name="fiscalAddress"
        label="investors.attributes.address"
        placeholder="investors.wizard.placeholders.address"
        required
      />
      <div className="grid gap-(--card-gap) sm:grid-cols-2">
        <WizardTextField
          name="city"
          label="investors.attributes.city"
          placeholder="investors.wizard.placeholders.city"
          required
        />
        <WizardTextField
          name="postalcode"
          label="investors.attributes.postal_code"
          placeholder="investors.wizard.placeholders.postal_code"
          required
        />
      </div>
      <div className="grid gap-(--card-gap) sm:grid-cols-2">
        <Field label={t("investors.attributes.country")} required>
          <OptionSelect
            value={form.watch("country")}
            options={getCountryOptions(SUPPORTED_COUNTRY_CODES, i18n.language)}
            label={t("investors.attributes.country")}
            placeholder={t("investors.wizard.placeholders.country")}
            onValueChange={(country) => {
              if (country) form.setValue("country", country, { shouldValidate: true });
            }}
          />
        </Field>
        <Field label={t("investors.attributes.language")} required>
          <OptionSelect<Language>
            value={form.watch("language") as Language}
            options={LANGUAGES.map((language) => ({
              value: language,
              label: languageLabels[language],
            }))}
            label={t("investors.attributes.language")}
            placeholder={t("investors.wizard.placeholders.language")}
            onValueChange={(language) => {
              if (language) form.setValue("language", language, { shouldValidate: true });
            }}
          />
        </Field>
      </div>
    </>
  );
}
